// extracted by css-extract-rspack-plugin
export default {"Box":"InfobarPopover-module__Box__t_BaS7F","CircleOcticon":"InfobarPopover-module__CircleOcticon__MyTZt_h","success":"InfobarPopover-module__success__JGC0tnP"};